"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryPathTowards = exports.run = exports.isNextTo4 = exports.isNextTo8 = exports.calculateMonsterVision = exports.canSee = exports.getPath = exports.tryMoveMonster = exports.create = exports.EAiMode = exports.EAiState = void 0;
var ROT = __importStar(require("rot-js"));
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueDijkstra_catFlee_1 = require("../map/rogueDijkstra_catFlee");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueTester_7drl_2023_1 = require("../scene/rogueTester_7drl_2023");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueMonsters_sidecar_1 = require("./rogueMonsters-sidecar");
var EAiState;
(function (EAiState) {
    EAiState[EAiState["Sleep"] = 0] = "Sleep";
    EAiState[EAiState["ChasePlayer"] = 1] = "ChasePlayer";
    // Stationary,
    EAiState[EAiState["Wander"] = 2] = "Wander";
    EAiState[EAiState["Player"] = 3] = "Player";
})(EAiState = exports.EAiState || (exports.EAiState = {}));
var EAiMode;
(function (EAiMode) {
    EAiMode[EAiMode["Player"] = 0] = "Player";
    EAiMode[EAiMode["AttackOnSight"] = 1] = "AttackOnSight";
    EAiMode[EAiMode["CatFlee"] = 2] = "CatFlee";
    EAiMode[EAiMode["DogFlee"] = 3] = "DogFlee";
    EAiMode[EAiMode["Fire"] = 4] = "Fire";
})(EAiMode = exports.EAiMode || (exports.EAiMode = {}));
var create = function (mode) {
    var obj = {
        targetX: 0,
        targetY: 0,
        targetMonster: null,
        state: EAiState.Sleep,
        mode: mode,
        isAlerted: false,
    };
    if (mode === EAiMode.Player) {
        obj.state = EAiState.Player;
    }
    return obj;
};
exports.create = create;
var tryMoveMonster = function (map, m, x, y) {
    var usedUpMove = false;
    if (m.isCaged) {
        return;
    }
    if (map) {
        var tile = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
        if (tile) {
            // let eTile = tile.eTile
            var mAt = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
            if (mAt) {
                if (mAt.isPlayer || mAt.data.isFriendly) {
                    if (m.data.isFriendly) {
                        usedUpMove = true;
                    }
                    else {
                        if (m.data.canAttack) {
                            var hitChance = 0.5;
                            if (m.data.isFire) {
                                var h = (0, rogueTester_7drl_2023_1.getHouse)();
                                if (h) {
                                    hitChance = h.difficulty.fireHitChance;
                                }
                            }
                            var didHit = rando_sidecar_1.rando.chance(hitChance);
                            if (mAt.isPlayer) {
                                if (didHit) {
                                    if (rogueStats_sidecar_1.rogueStats.getStats().iceArmorStrength > 0) {
                                        rogueStats_sidecar_1.rogueStats.getStats().iceArmorStrength -= 1;
                                        rogueStats_sidecar_1.rogueStats.setMessage("Your ice armor protects you!");
                                    }
                                    else {
                                        // Attack!
                                        rogueStats_sidecar_1.rogueStats.setMessage("The ".concat(m.data.name, " hurts you!"));
                                        rogueMonsters_sidecar_1.rogueMonsters.damage(mAt, 1, 'fire');
                                    }
                                }
                                else {
                                    // Miss
                                    rogueStats_sidecar_1.rogueStats.setMessage("You dodge the ".concat(m.data.name, "!"));
                                }
                            }
                            else {
                                if (didHit) {
                                    // Attack!
                                    if (tile.eVision === rogueMaps_1.EVision.Seen) {
                                        rogueStats_sidecar_1.rogueStats.setMessage("The ".concat(m.data.name, " hurts the ").concat(mAt.data.name, "!"));
                                    }
                                    rogueMonsters_sidecar_1.rogueMonsters.damage(mAt, 1, 'fire');
                                }
                                else {
                                    // Miss
                                    // rogueStats.setMessage(`You dodge the ${m.data.name}!`)
                                }
                            }
                            // m.hp -= 1
                            // if (m.hp <= 0) {
                            //   rogueStats.setMessage('You killed the ' + m.data.name + '!')
                            //   rogueStats.addExp(m.data.exp)
                            //   rogueMonsters.kill(m)
                            // }
                        }
                        usedUpMove = true;
                    }
                }
                usedUpMove = true;
            }
            else {
                if (rogueMaps_sidecar_1.rogueMaps.isPassible(map, x, y)) {
                    if (m.data.canMove) {
                        if (m.data.isHellHound) {
                            var newF = rogueMonsters_sidecar_1.rogueMonsters.create('f');
                            rogueMonsters_sidecar_1.rogueMonsters.setPos(newF, m.x, m.y);
                        }
                        rogueMonsters_sidecar_1.rogueMonsters.setPos(m, x, y);
                    }
                }
            }
        }
    }
};
exports.tryMoveMonster = tryMoveMonster;
var getPath = function (map, monster, x, y) {
    var path = [];
    // https://ondras.github.io/rot.js/manual/#path
    /* input callback informs about map structure */
    var passableCallback = function (x, y) {
        return rogueMaps_sidecar_1.rogueMaps.isPassible(map, x, y);
    };
    /* prepare path to given coords */
    var astar = new ROT.Path.AStar(x, y, passableCallback);
    /* compute from given coords #1 */
    astar.compute(monster.x, monster.y, function (x, y) {
        // display.draw(x, y, '', '', '#800')
        path.push({ x: x, y: y });
    });
    return path;
};
exports.getPath = getPath;
var canSee = function (map, m, mTarget) {
    // Expensive fov calculation to see if one monster can see the other
    var visionRange = 7;
    var canSee = false;
    (0, exports.calculateMonsterVision)(m, map, visionRange, function (x, y, r, visibility) {
        var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
        if (m === mTarget) {
            canSee = true;
        }
    });
    return canSee;
};
exports.canSee = canSee;
var calculateMonsterVision = function (monster, map, visionRange, cb) {
    var lightPasses = rogueMaps_sidecar_1.rogueMaps.createLightPasses(map);
    var fov = new ROT.FOV.PreciseShadowcasting(lightPasses);
    fov.compute(monster.x, monster.y, visionRange, function (x, y, r, visibility) {
        cb(x, y, r, visibility);
        // var ch = r ? '' : '@'
        // var color = data[x + ',' + y] ? '#aa0' : '#660'
        // display.draw(x, y, ch, '#fff', color)
        // setVisibility(map, x, y, EVision.Seen)
    });
};
exports.calculateMonsterVision = calculateMonsterVision;
var isNextTo8 = function (map, x, y, cb) {
    var directions8 = [
        { x: -1, y: -1 },
        { x: 0, y: -1 },
        { x: 1, y: -1 },
        { x: -1, y: 0 },
        { x: 1, y: 0 },
        { x: -1, y: 1 },
        { x: 0, y: 1 },
        { x: 1, y: 1 },
    ];
    while (directions8.length > 0) {
        var dir = rando_sidecar_1.rando.sampleAndRemove(directions8);
        var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, x + dir.x, y + dir.y);
        if (t) {
            if (cb(t)) {
                return t;
            }
        }
    }
    return null;
};
exports.isNextTo8 = isNextTo8;
var isNextTo4 = function (map, x, y, cb) {
    var directions4 = [
        { x: 0, y: -1 },
        { x: -1, y: 0 },
        { x: 1, y: 0 },
        { x: 0, y: 1 },
    ];
    while (directions4.length > 0) {
        var dir = rando_sidecar_1.rando.sampleAndRemove(directions4);
        var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, x + dir.x, y + dir.y);
        if (t) {
            if (cb(t)) {
                return t;
            }
        }
    }
    return null;
};
exports.isNextTo4 = isNextTo4;
var run = function (monster, map) {
    var ai = monster.ai;
    if (monster.isCaged) {
        return;
    }
    if (ai.isAlerted) {
        ai.isAlerted = false; // Reset alert flag
    }
    if (ai.mode === EAiMode.Player) {
        ai.state = EAiState.Player;
        return;
    }
    var processSleepMode = function (nextState) {
        var visionRange = 4;
        if (!monster.data.canMove) {
            visionRange = 2;
        }
        // Wake up if hurt
        if (monster.hp < monster.data.maxHp) {
            console.log('waking up from hurt', monster.data.char, monster.hp);
            ai.isAlerted = true;
            ai.state = nextState;
        }
        (0, exports.calculateMonsterVision)(monster, map, visionRange, function (x, y, r, visibility) {
            var mAt = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
            if (mAt && mAt.isPlayer) {
                // chance of waking up
                if (rando_sidecar_1.rando.chance(mAt.data.detectChance) || !monster.data.canSleep) {
                    ai.isAlerted = true;
                    ai.state = nextState;
                    ai.targetX = x;
                    ai.targetY = y;
                    ai.targetMonster = mAt;
                }
            }
        });
    };
    var processChasePlayer = function () {
        var mTarget = ai.targetMonster;
        if (!mTarget) {
            var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
            var visionRange = 6;
            (0, exports.calculateMonsterVision)(monster, map, visionRange, function (x, y, r, visibility) {
                var mAt = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
                if (mAt && mAt.isPlayer) {
                    mTarget = mAt;
                }
            });
        }
        if (!mTarget || mTarget.isDead) {
            // ai.state = EAiState.ChasePlayer
        }
        else {
            if ((0, exports.canSee)(map, monster, mTarget)) {
                ai.targetX = mTarget.x;
                ai.targetY = mTarget.y;
                (0, exports.tryPathTowards)(map, monster, ai.targetX, ai.targetY);
            }
            else {
                // Go to last seen location
                if (rogueDef_sidecar_1.rogueDef.isSameSpot(monster.x, monster.y, ai.targetX, ai.targetY)) {
                    // ai.state = EAiState.Wander
                }
                else {
                    (0, exports.tryPathTowards)(map, monster, ai.targetX, ai.targetY);
                }
            }
        }
    };
    if (ai.mode === EAiMode.Fire) {
        // Check if we are near monster
        var tNext = (0, exports.isNextTo4)(map, monster.x, monster.y, function (t) {
            var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(t.x, t.y);
            if (m && (m.isPlayer || m.data.isFriendly)) {
                return true;
            }
            return false;
        });
        if (tNext) {
            (0, exports.tryMoveMonster)(map, monster, tNext.x, tNext.y);
        }
    }
    if (ai.mode === EAiMode.CatFlee) {
        var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, monster.x, monster.y);
        if (!monster.isSaved) {
            // console.log(
            //   'check saved',
            //   t?.dijkstra_catFlee,
            //   monster.data.char,
            //   monster.isSaved,
            // )
            var tNext = (0, exports.isNextTo4)(map, monster.x, monster.y, function (t) {
                return t.dijkstra_catFlee <= 1;
            });
            if (tNext) {
                monster.isSaved = true;
                rogueStats_sidecar_1.rogueStats.addScore(10);
                rogueStats_sidecar_1.rogueStats.setMessage('The ' + monster.data.name + ' is saved!');
            }
        }
        if (ai.state === EAiState.Sleep) {
            processSleepMode(EAiState.ChasePlayer);
        }
        else {
            if (monster.isSaved) {
                // return
            }
            var directions = [
                { x: 0, y: 0 },
                { x: 0, y: -1 },
                { x: 0, y: 1 },
                { x: -1, y: 0 },
                { x: 1, y: 0 },
            ];
            var lowest_1 = rogueDijkstra_catFlee_1.dijkstra_max;
            var direction_1 = { x: 0, y: 0 };
            directions.forEach(function (dir) {
                var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, monster.x + dir.x, monster.y + dir.y);
                if (t) {
                    if (!rogueMaps_sidecar_1.rogueMaps.isPassibleT(t)) {
                        return; // Can't move here
                    }
                    if (rogueMonsters_sidecar_1.rogueMonsters.getAt(t.x, t.y)) {
                        return; // Can't move here
                    }
                    if (t.dijkstra_catFlee < lowest_1) {
                        lowest_1 = t.dijkstra_catFlee;
                        direction_1 = dir;
                    }
                }
            });
            if (lowest_1 < rogueDijkstra_catFlee_1.dijkstra_max) {
                rogueMonsters_sidecar_1.rogueMonsters.setPos(monster, monster.x + direction_1.x, monster.y + direction_1.y);
            }
        }
    }
    if (ai.mode === EAiMode.DogFlee) {
        if (ai.state === EAiState.Sleep) {
            processSleepMode(EAiState.ChasePlayer);
        }
        else {
            // Check if we are near grass
            var directions8 = [
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -1, y: 0 },
                { x: 1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: 1 },
                { x: 1, y: 1 },
            ];
            var foundGrass = false;
            while (directions8.length > 0) {
                var d = rando_sidecar_1.rando.sampleAndRemove(directions8);
                var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, monster.x + d.x, monster.y + d.y);
                if (t) {
                    if (t.eTile === rogueMaps_1.ETile.Grass) {
                        if (rogueMaps_sidecar_1.rogueMaps.isOpenT(map, t)) {
                            foundGrass = true;
                            (0, exports.tryMoveMonster)(map, monster, t.x, t.y);
                            break;
                        }
                    }
                }
            }
            if (foundGrass) {
                console.log('found grass');
                ai.mode = EAiMode.CatFlee; // Cat behavior now, flee to exit
            }
            else {
                processChasePlayer();
            }
        }
    }
    // if (ai.mode === EAiMode.Stationary) {
    // }
    if (ai.mode === EAiMode.AttackOnSight) {
        if (ai.state === EAiState.Sleep) {
            processSleepMode(EAiState.ChasePlayer);
        }
        else if (ai.state === EAiState.ChasePlayer) {
            processChasePlayer();
        }
    }
};
exports.run = run;
var tryPathTowards = function (map, monster, x, y) {
    if (rogueDef_sidecar_1.rogueDef.isNextTo8(monster.x, monster.y, x, y)) {
        (0, exports.tryMoveMonster)(map, monster, x, y);
        return;
    }
    if (monster.data.canMove) {
        var path = (0, exports.getPath)(map, monster, x, y);
        console.log('path', path);
        if (path.length > 1) {
            // First move is current location, need second move
            (0, exports.tryMoveMonster)(map, monster, path[1].x, path[1].y);
        }
    }
};
exports.tryPathTowards = tryPathTowards;
